import DataSource, { DataSourceService, DataSourceServiceMapDelegate, DataSourceData } from "./datasource";

export default class AjaxDataSourceService implements DataSourceService {

    private _xhttp: XMLHttpRequest | undefined;

    private parameterMap: DataSourceServiceMapDelegate | undefined;
    private headerMap: DataSourceServiceMapDelegate | undefined;

    constructor(
        public readonly name: string,
        public readonly method: "GET" | "POST" | "PUT" | "DEL",
        public readonly url: string) {
    }

    setParameterMap(handler: DataSourceServiceMapDelegate): AjaxDataSourceService {
        this.parameterMap = handler;
        return this;
    }

    setHeaderMap(handler: DataSourceServiceMapDelegate): AjaxDataSourceService {
        this.headerMap = handler;
        return this;
    }

    fetch(dataSource: DataSource, argument?: any): Promise<DataSourceData> {

        return new Promise(resolve => {

            let headers: Record<string, string> = {};

            const currentFilterText: string = dataSource?.filters[0]?.toString() || '';

            // Get Headers
            if (this.headerMap) {
                headers = this.headerMap({
                    argument: argument,
                    filterText: currentFilterText
                });
            }

            if (!headers["Content-Type"]) {
                headers["Content-Type"] = "application/json;charset=UTF-8";
            }

            // Build Url
            const invokeUrl = this.buildUrl(dataSource, argument);

            // Abort if another request is executing
            if (this._xhttp != undefined && this._xhttp.readyState !== 4) {
                this._xhttp.abort();
            }

            // Request using Ajax
            this._xhttp = new XMLHttpRequest();
            this._xhttp.addEventListener('readystatechange', ev => {
                const xhttp = ev.target as XMLHttpRequest;

                if (xhttp.readyState === 4 && xhttp.status === 200) {
                    const data: DataSourceData = xhttp.responseText ? JSON.parse(xhttp.responseText) : null;
                    resolve(data);
                }
            });

            this._xhttp.open(this.method, invokeUrl, true);

            // Add Headers to Ajax Request
            Object.entries(headers).forEach(([key, value]) => this._xhttp?.setRequestHeader(key, value));

            // Send data
            const req = typeof argument === 'object'
                ? JSON.stringify(argument)
                : argument;

            this._xhttp.send(req || null);
        });
    }

    private buildUrl(dataSource: DataSource, argument: any): string {

        let parameters: Record<string, string> = {};

        const currentFilterText: string = dataSource?.filters[0]?.toString() || '';

        // Get Parameters
        if (this.parameterMap) {
            parameters = this.parameterMap({
                argument: argument,
                filterText: currentFilterText
            });
        }

        // Build QueryString
        let queryString = "";
        Object.entries(parameters).forEach(([key, value]) => {
            queryString += `${queryString !== "" ? "&" : ""}${key}=${isNullOrUndefined(value) ? "" : encodeURIComponent(value.toString())}`;
        });

        // Build Url
        const invokeUrl = this.url +
            (queryString ? (this.url.indexOf("?") === -1 ? "?" : "&") + queryString : "");

        return invokeUrl;
    }

}

function isNullOrUndefined(value: any): boolean {
    return value === undefined || value === null;
}




